module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_8017.9bf03ab8.png";